var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.631,
    height: 32,
    viewBox: "0 0 20.631 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734",
    transform: "translate(-758.233 -1216.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53412",
    "data-name": "Path 53412",
    d: "M781.721,1227.261c0-1.642-.1-3.291.022-4.924a6.569,6.569,0,0,1,5.856-5.874,6.669,6.669,0,0,1,7.381,6.65q.008,4.077,0,8.154a6.655,6.655,0,0,1-13.308.212c-.018-1.406,0-2.812,0-4.219Z",
    transform: "translate(-19.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53413",
    "data-name": "Path 53413",
    d: "M769.678,1316.208v4.563c.135.006.26.017.385.017.709,0,1.419-.006,2.128,0a1.112,1.112,0,1,1,0,2.22q-3.636.009-7.271,0a1.113,1.113,0,1,1-.005-2.221c.7-.009,1.4,0,2.093,0h.423v-.424c0-1.253-.008-2.505.006-3.758,0-.292-.055-.415-.384-.471a10.073,10.073,0,0,1-8.33-7.1,13.961,13.961,0,0,1-.484-3.03,1.05,1.05,0,0,1,1.041-1.151,1.063,1.063,0,0,1,1.163,1.071,7.963,7.963,0,0,0,1.2,4.209,7.846,7.846,0,0,0,7.125,3.877,8.033,8.033,0,0,0,7.7-6.443,16.963,16.963,0,0,0,.179-1.69,1.11,1.11,0,0,1,2.217.107,10.336,10.336,0,0,1-8.907,10.174C769.875,1316.172,769.794,1316.187,769.678,1316.208Z",
    transform: "translate(0 -74.589)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/MuteIcon.237529bd8737cd26f72a95c2a51f620c.svg";
export { ForwardRef as ReactComponent };